module.exports = __webpack_public_path__ + "media/images/shared/logotypes/logo_skurup-7ea35a923f08969bf522c5a12fc141e7.png";